import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { maxWidth } from '../../helpers/media-queries';
import { isIPhone, browser } from '../../helpers/browser-detection';

const styles = ({ palette }) => ({
  root: {
    border: 0,
    marginTop: '60px',
    cursor: 'pointer',
    borderStyle: 'solid',
    borderWidth: '8px',
    borderImage:
      'url(./static/images/game/border.png) 110 139 137 137 fill / 1 / 0 round',

    [maxWidth.lg]: {
      overflow: 'hidden',
      marginTop: '6vw',
      borderWidth: '5px',
    },

    '&.fullscreen': {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9999,
      backgroundColor: 'black',
      margin: 0,
      padding: 0,
      border: 0,
      width: '100vw',
      height: '100vh',

      // transform: `rotate(-${window.orientation-90}deg)`,
    },
  },

  iframe: {
    width: '100%',
    height: '100px',
  },
});

const mapper = (stores) => ({
  fullscreen: stores.ui.fullscreen,
  gameIsVisible: stores.ui.gameIsVisible,
  setGameIsVisible: (gameIsVisible) => {
    if (gameIsVisible) {
      const trailer = document.getElementById('trailer');
      if (trailer) trailer.pause();
      stores.soundtrack.pause();
    }
    stores.ui.setGameIsVisible(gameIsVisible);
  },
  setFullscreen: (fullscreen) => stores.ui.setFullscreen(fullscreen),
});

class GameIframe extends Component {
  state = {
    width: window.screen.width + 'px',
    height: window.screen.height + 'px',
  };

  timestamp = Date.now() / 1000;

  frameRef = React.createRef();

  props = {
    targetOrigin: '*',
    serializeMessage: true,
  };

  componentDidMount() {
    this._handleResize();
    window.addEventListener('message', this._onReceiveMessage);
    window.addEventListener('resize', this._handleResize);
    window.addEventListener('scroll', this._handleScroll);
    window.addEventListener('keyup', this._handleKeyUp);
    // document.querySelector('iframe').addEventListener("keyup", this._handleKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this._onReceiveMessage);
    window.removeEventListener('resize', this._handleResize);
    window.removeEventListener('scroll', this._handleScroll);
    window.removeEventListener('keyup', this._handleKeyUp);
    // document.querySelector('iframe').removeEventListener("keyup", this._handleKeyUp);
  }

  componentWillUpdate(nextProps) {
    if (this.props.fullscreen !== nextProps.fullscreen) {
      // this.sendMessage({fnName: 'setFullscreen', value: JSON.stringify({ value: !!nextProps.fullscreen })});
      // this.props.setFullscreen(!!nextProps.fullscreen);
      if (nextProps.fullscreen && !isNaN(nextProps.fullscreen)) {
        this._handleResize();
        // let width = document.documentElement.clientWidth+'px';
        // let height = document.documentElement.clientHeight+'px';
        // this.setState({ width, height, minWidth: width, minHeight: height });
      }
    }

    if (!this.props.gameIsVisible !== nextProps.gameIsVisible) {
      this.sendMessage({
        fnName: 'setMuted',
        value: JSON.stringify({ value: !nextProps.gameIsVisible }),
      });
    }
  }

  render() {
    const { classes, handlereceivemessage, fullscreen, ...props } = this.props;
    const url =
      process.env.NODE_ENV !== 'production'
        ? 'https://deadlyarcade.dev.pushstart.com.br'
        : '';
    return (
      <iframe
        src={`${url}/game/index.html?${this.timestamp}`}
        // src={`http://10.10.2.1:50000?${this.timestamp}`}
        title="juego"
        ref={this.frameRef}
        allowFullScreen
        scrolling={'no'}
        frameBorder="0"
        className={classNames(classes.root, {
          fullscreen: !!fullscreen,
        })}
        {...this.state}
        {...props}
      />
    );
  }

  sendMessage(postMessageData) {
    // Using postMessage data from props will result in a subtle but deadly bug,
    // where old data from props is being sent instead of new postMessageData.
    // This is because data sent from componentWillReceiveProps is not yet in props but only in nextProps.

    let serializedData = this._serializePostMessageData(postMessageData);

    serializedData = Object.assign(
      {
        type: 'Rex_FrameMessage.Return',
        sender: 'app',
      },
      serializedData
    );

    this.frameRef.current.contentWindow.postMessage(serializedData, '*');
    // console.log(serializedData, targetOrigin);
  }

  _onReceiveMessage = (event) => {
    const { handleReceiveMessage } = this.props;
    const { data = {} } = event;

    switch (data.fnName) {
      case 'loaded':
        if (window.ga) {
          window.ga('send', 'event', 'Videos', 'play', 'Start');
        }
        this.sendMessage({ fnName: 'start', value: '' });
        break;
      case 'usingIphoneFullscreen':
        this.sendMessage({
          fnName: 'usingIphoneFullscreen',
          value: JSON.stringify({ value: !!isIPhone() }),
        });
        break;
      case 'setFullscreen':
        let { params = [{}] } = data;
        if (typeof params[0] === 'string') {
          params = JSON.parse(params[0]);
        }
        this.props.setFullscreen(!!params.value);
        break;

      default:
        break;
    }

    if (handleReceiveMessage) {
      handleReceiveMessage(event);
    }
  };

  _serializePostMessageData(data) {
    // Rely on the browser's built-in structured clone algorithm for serialization of the
    // message as described in
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
    if (!this.props.serializeMessage) {
      return data;
    }

    // To be on the safe side we can also ignore the browser's built-in serialization feature
    // and serialize the data manually.
    if (typeof data === 'object') {
      return JSON.stringify(data);
    } else if (typeof data === 'string') {
      return data;
    } else {
      return `${data}`;
    }
  }

  _handleResize = () => {
    let { innerWidth: width } = window,
      height;
    if (width > 1080) width = 1080;
    width = width * 0.7;
    height = (width / 15.8) * 9;
    this.setState({ width: width + 'px', height: height + 'px' });
    this._handleScroll();
  };

  _handleScroll = () => {
    const { fullscreen, setGameIsVisible } = this.props;
    let { scrollY: y } = window;
    let { offsetHeight: height } = document.querySelector('.call-to-action');

    if (browser.isBrowser('Internet Explorer')) y = window.pageYOffset;

    height *= 0.75;
    const isVisible = y < height;

    if (!isIPhone() || (!!isIPhone() && !fullscreen)) {
      setGameIsVisible && setGameIsVisible(isVisible);
    }
  };

  _handleKeyUp = (ev) => {
    const { setFullscreen } = this.props;
    if (ev.key === 'Escape') {
      setFullscreen(false);
      this.sendMessage({
        fnName: 'setFullscreen',
        value: JSON.stringify({ value: false }),
      });
    }
  };
}

export default inject(mapper)(withStyles(styles)(GameIframe));
